"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.grades.features.advancedPrompts': 'Advanced Prompts',
    'account.grades.features.promptAssist': 'Prompt Assistance',
    'account.grades.features.antiHallucination': 'Anti-Hallucination',
    'account.grades.features.advancedReports': 'Advanced Reports',
    'account.grades.features.chatThreadSharing': 'Chat Thread Sharing',
    'account.grades.features.customBranding': 'Custom Branding',
    'account.grades.features.widgets': 'Widgets',
    'account.grades.features.customAiModels': 'Custom AI Models',
    'account.grades.features.voiceAgent': 'Voice Agent',
    'account.grades.features.writingStyles': 'Writing Styles',
    'account.grades.features.maxAvatars': 'Avatars',
    'account.grades.features.maxUsers': 'Users',
    'account.grades.features.maxProjects': 'Projects',
    'account.grades.features.maxKnowledge': 'Knowledge Entries',
    'account.grades.free': 'Free',
    'account.grades.free.description': 'Basic features for getting started',
    'account.grades.free.feature1': 'Limited monthly usage',
    'account.grades.free.feature2': 'Basic AI models',
    'account.grades.free.feature3': 'Community support',
    'account.grades.basic': 'Basic',
    'account.grades.basic.description': 'Enhanced features for regular users',
    'account.grades.basic.feature1': 'Increased monthly usage',
    'account.grades.basic.feature2': 'Standard AI models',
    'account.grades.basic.feature3': 'Email support',
    'account.grades.pro': 'Pro',
    'account.grades.pro.description': 'Advanced features for professionals',
    'account.grades.pro.feature1': 'High monthly usage',
    'account.grades.pro.feature2': 'Premium AI models',
    'account.grades.pro.feature3': 'Priority support',
    'account.grades.ultra': 'Ultra',
    'account.grades.ultra.description': 'Maximum features for power users',
    'account.grades.ultra.feature1': 'Unlimited usage',
    'account.grades.ultra.feature2': 'All AI models',
    'account.grades.ultra.feature3': 'Dedicated support',
};
